import { render } from "./form_user_site_permission.vue?vue&type=template&id=06970cac"
import script from "./form_user_site_permission.vue?vue&type=script&lang=js"
export * from "./form_user_site_permission.vue?vue&type=script&lang=js"

import exportComponent from "/home/deployer/asset-portal/releases/20260828153143/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__